import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ServicesPage() {
  const services = [
    {
      title: 'Schengen Bölgesi C Tipi Vizeler',
      slug: 'schengen-c-tipi-vizeler',
      icon: 'ri-passport-line',
      image: 'https://public.readdy.ai/ai/img_res/5b04ddb10199c444a0affdb5ceb5a193.jpg',
      description: 'Turistik, ticari ve aile ziyareti amaçlı kısa süreli vizeler',
      details: [
        'Turist vizesi başvuruları',
        'İş vizesi danışmanlığı',
        'Aile ziyareti vizesi',
        'Konferans ve etkinlik vizesi',
      ],
    },
    {
      title: 'Schengen Bölgesi D Tipi Vizeler',
      slug: 'schengen-d-tipi-vizeler',
      icon: 'ri-time-line',
      image: 'https://readdy.ai/api/search-image?query=Long%20term%20residence%20permit%20card%20and%20national%20visa%20documents%20with%20European%20flag%20on%20modern%20office%20desk%20professional%20immigration%20concept%20clean%20bright%20lighting%20minimal%20white%20background&width=800&height=600&seq=schengen-d-visa-002&orientation=landscape',
      description: 'Uzun süreli ve ulusal vize başvuruları',
      details: [
        'Öğrenci vizesi başvuruları',
        'Çalışma vizesi danışmanlığı',
        'Uzun süreli ikamet vizesi',
        'Aile birleşimi vizesi',
      ],
    },
    {
      title: 'Amerika Vizesi',
      slug: 'amerika-vizesi',
      icon: 'ri-flight-takeoff-line',
      image: 'https://readdy.ai/api/search-image?query=United%20States%20visa%20application%20documents%20with%20American%20passport%20and%20DS-160%20form%20on%20professional%20desk%20USA%20embassy%20interview%20preparation%20bright%20clean%20background%20business%20travel%20concept&width=800&height=600&seq=usa-visa-003&orientation=landscape',
      description: 'B1/B2, öğrenci ve diğer vize türleri',
      details: [
        'DS-160 form doldurma',
        'Mülakat hazırlığı',
        'Evrak kontrolü ve hazırlık',
        'Randevu alma hizmeti',
      ],
    },
    {
      title: 'İngiltere Vizesi',
      slug: 'ingiltere-vizesi',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=United%20Kingdom%20visa%20application%20with%20British%20passport%20and%20immigration%20documents%20on%20elegant%20office%20desk%20UK%20travel%20permit%20professional%20lighting%20clean%20minimal%20background%20London%20Big%20Ben%20subtle%20background&width=800&height=600&seq=uk-visa-004&orientation=landscape',
      description: 'UK turist, öğrenci ve iş vizesi danışmanlığı',
      details: [
        'Standard Visitor Visa',
        'Student Visa başvuruları',
        'Work Visa danışmanlığı',
        'Biyometrik randevu desteği',
      ],
    },
    {
      title: 'Oturum Kartı Başvuruları',
      slug: 'oturum-karti-basvurulari',
      icon: 'ri-home-line',
      image: 'https://readdy.ai/api/search-image?query=Residence%20permit%20card%20and%20immigration%20documents%20with%20house%20keys%20on%20modern%20desk%20permanent%20residency%20application%20concept%20bright%20professional%20lighting%20clean%20white%20background%20relocation%20theme&width=800&height=600&seq=residence-permit-005&orientation=landscape',
      description: 'Yurt dışı oturum izni ve ikamet kartı başvuru süreçleri',
      details: [
        'Kısa süreli oturum izni',
        'Uzun süreli oturum izni',
        'Daimi oturum başvuruları',
        'Oturum yenileme işlemleri',
      ],
    },
    {
      title: 'Göçmenlik ve Aile Birleşimi Süreçleri',
      slug: 'gocmenlik-aile-birlesiimi',
      icon: 'ri-group-line',
      image: 'https://readdy.ai/api/search-image?query=Family%20reunion%20immigration%20documents%20with%20family%20photos%20and%20visa%20papers%20on%20warm%20desk%20setting%20migration%20and%20relocation%20concept%20emotional%20bright%20lighting%20clean%20background%20unity%20theme&width=800&height=600&seq=family-reunion-006&orientation=landscape',
      description: 'Göçmenlik süreçleri ve aile birleşimi başvuruları',
      details: [
        'Aile birleşimi vizesi',
        'Evlilik vizesi başvuruları',
        'Çocuk vizesi süreçleri',
        'Göçmenlik danışmanlığı',
      ],
    },
    {
      title: 'Kapı Vizeleri',
      slug: 'kapi-vizeleri',
      icon: 'ri-door-open-line',
      image: 'https://readdy.ai/api/search-image?query=Airport%20visa%20on%20arrival%20counter%20with%20passport%20control%20documents%20and%20boarding%20pass%20international%20terminal%20bright%20modern%20setting%20clean%20professional%20background%20border%20crossing%20concept&width=800&height=600&seq=visa-on-arrival-007&orientation=landscape',
      description: 'Havalimanında veya sınır kapısında alınabilen vize işlemleri',
      details: [
        'Türkiye kapı vizesi',
        'Diğer ülke kapı vizeleri',
        'Evrak hazırlığı',
        'Bilgilendirme hizmeti',
      ],
    },
    {
      title: 'E-Vizeler',
      slug: 'e-vizeler',
      icon: 'ri-smartphone-line',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20visa%20application%20on%20smartphone%20and%20laptop%20screen%20with%20digital%20passport%20online%20e-visa%20system%20modern%20technology%20bright%20clean%20background%20digital%20travel%20authorization%20concept&width=800&height=600&seq=e-visa-008&orientation=landscape',
      description: 'Online vize başvuruları ve elektronik vize işlemleri',
      details: [
        'E-vize başvuru desteği',
        'Online form doldurma',
        'Ödeme işlemleri',
        'Vize takip hizmeti',
      ],
    },
    {
      title: 'Özel Danışmanlık Hizmetleri',
      slug: 'ozel-danismanlik',
      icon: 'ri-user-star-line',
      image: 'https://readdy.ai/api/search-image?query=VIP%20visa%20consultation%20service%20with%20professional%20consultant%20and%20client%20meeting%20in%20modern%20office%20premium%20immigration%20advisory%20elegant%20setting%20bright%20lighting%20clean%20background%20personalized%20service%20concept&width=800&height=600&seq=vip-consultation-009&orientation=landscape',
      description: 'Kişiye özel vize danışmanlık çözümleri',
      details: [
        'Vize reddi analizi',
        'İtiraz süreçleri',
        'Karmaşık başvurular',
        'VIP hizmet paketi',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-2xl sm:text-3xl lg:text-5xl text-darkBlue mb-4 sm:mb-6">
              İzmir Vize Danışmanlık
            </h1>
            <p className="font-body text-xs sm:text-sm lg:text-lg text-gray-600 leading-relaxed mb-3 sm:mb-4">
              Yurt dışı seyahat planları, doğru vize süreci yönetilmediğinde zaman kaybına ve maddi zarara dönüşebilir. izmirvizedanismanlik.net, İzmir merkezli profesyonel kadrosu ile vize başvurularınızı en doğru şekilde yönetmeyi hedefler.
            </p>
            <p className="font-body text-xs sm:text-sm lg:text-lg text-gray-600 leading-relaxed mb-3 sm:mb-4">
              Yüksek onay oranı, şeffaf hizmet anlayışı, iade garantisi ve profesyonel evrak takibi ile süreci sizin adınıza güvenle yürütür.
            </p>
            <p className="font-body text-xs sm:text-sm lg:text-lg text-gray-600 leading-relaxed">
              10 yılı aşkın sektör deneyimimiz sayesinde, farklı ülke ve vize türlerinde başvuru yapan danışanlarımıza doğru yönlendirme sağlıyor, başvuruların eksiksiz ve hatasız ilerlemesini önceliklendiriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-10 sm:py-14 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-darkBlue mb-6 sm:mb-8 text-center">
            İzmir Vize Danışmanlık Hizmetlerimiz
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={`/hizmetler/${service.slug}`}
                className="group bg-white rounded-lg sm:rounded-xl lg:rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="h-24 sm:h-32 lg:h-48 relative overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end justify-center pb-2 sm:pb-3 lg:pb-4">
                    <i className={`${service.icon} text-white text-2xl sm:text-3xl lg:text-5xl`}></i>
                  </div>
                </div>
                <div className="p-2 sm:p-3 lg:p-6 space-y-1 sm:space-y-2 lg:space-y-4">
                  <h3 className="font-heading font-bold text-[10px] sm:text-xs lg:text-xl text-darkBlue group-hover:text-secondary transition-colors leading-tight">
                    {service.title}
                  </h3>
                  <p className="font-body text-gray-600 text-[9px] sm:text-[10px] lg:text-sm leading-relaxed hidden sm:block">
                    {service.description}
                  </p>
                  <ul className="space-y-0.5 sm:space-y-1 lg:space-y-2 hidden lg:block">
                    {service.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start space-x-1 sm:space-x-2 font-body text-[9px] sm:text-[10px] lg:text-sm text-gray-600">
                        <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0 text-[10px] lg:text-base"></i>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center space-x-1 text-secondary font-semibold hover:text-secondary/80 transition-colors pt-1 sm:pt-2">
                    <span className="font-body text-[9px] sm:text-[10px] lg:text-sm">Detaylı Bilgi</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform text-xs lg:text-base"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-10 sm:py-14 lg:py-20 bg-lightBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-darkBlue mb-6 sm:mb-8 text-center">
            İzmir Vize Danışmanlık Süreci Nasıl İşler?
          </h2>
          <div className="max-w-3xl mx-auto space-y-2 sm:space-y-3 lg:space-y-4">
            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 shadow-md">
              <h4 className="font-heading font-bold text-xs sm:text-sm lg:text-lg text-darkBlue">1. Ön Değerlendirme</h4>
            </div>
            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 shadow-md">
              <h4 className="font-heading font-bold text-xs sm:text-sm lg:text-lg text-darkBlue">2. Evrak Planlaması</h4>
            </div>
            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 shadow-md">
              <h4 className="font-heading font-bold text-xs sm:text-sm lg:text-lg text-darkBlue">3. Profesyonel Evrak Kontrolü</h4>
            </div>
            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 shadow-md">
              <h4 className="font-heading font-bold text-xs sm:text-sm lg:text-lg text-darkBlue">4. Başvuru ve Randevu Yönetimi</h4>
            </div>
            <div className="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 shadow-md">
              <h4 className="font-heading font-bold text-xs sm:text-sm lg:text-lg text-darkBlue">5. Süreç Takibi</h4>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-10 sm:py-14 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-darkBlue mb-6 sm:mb-8 text-center">
            Neden izmirvizedanismanlik.net Tercih Edilmeli?
          </h2>
          <div className="max-w-3xl mx-auto bg-lightBlue rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>%98'e varan başarı oranı</span>
              </li>
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>10+ yıl sektör deneyimi</span>
              </li>
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>İade garantili danışmanlık modeli</span>
              </li>
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>Güncel mevzuata hakim uzman ekip</span>
              </li>
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>Şeffaf fiyatlandırma</span>
              </li>
              <li className="flex items-start space-x-2 font-body text-xs sm:text-sm lg:text-base text-gray-700">
                <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                <span>Birebir danışman desteği</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 sm:py-14 lg:py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-white mb-3 sm:mb-4">
            Vize Başvurunuz İçin Hemen Başlayın
          </h2>
          <p className="font-body text-xs sm:text-sm lg:text-lg text-white/90 mb-4 sm:mb-6 lg:mb-8">
            Ücretsiz ön değerlendirme için bizimle iletişime geçin
          </p>
          <div className="flex flex-row items-center justify-center gap-2 sm:gap-3 lg:gap-4">
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 rounded-full font-body font-bold text-xs sm:text-sm lg:text-base transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              İletişime Geç
            </Link>
            <a
              href="tel:+905422671171"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border border-white sm:border-2 px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 rounded-full font-body font-bold text-xs sm:text-sm lg:text-base transition-all whitespace-nowrap"
            >
              +90 542 267 11 71
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
